export function ServiceCardSkeleton() {
  return (
    <div className="border border-gray-200 rounded-lg p-4 animate-pulse">
      <div className="space-y-3">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="h-5 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="flex items-center gap-3">
              <div className="h-4 bg-gray-200 rounded w-20"></div>
              <div className="h-4 bg-gray-200 rounded w-16"></div>
            </div>
          </div>
        </div>
        <div className="space-y-2">
          <div className="h-3 bg-gray-200 rounded w-full"></div>
          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
        </div>
      </div>
    </div>
  );
}

export function ProviderCardSkeleton() {
  return (
    <div className="border border-gray-200 rounded-lg p-4 animate-pulse">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 bg-gray-200 rounded-full flex-shrink-0"></div>
        <div className="flex-1 space-y-2">
          <div className="h-4 bg-gray-200 rounded w-2/3"></div>
          <div className="h-3 bg-gray-200 rounded w-1/2"></div>
        </div>
      </div>
    </div>
  );
}

export function TimeSlotSkeleton() {
  return (
    <div className="border border-gray-200 rounded-lg p-3 animate-pulse">
      <div className="space-y-2">
        <div className="h-4 bg-gray-200 rounded w-20 mx-auto"></div>
        <div className="h-3 bg-gray-200 rounded w-16 mx-auto"></div>
      </div>
    </div>
  );
}

export function DateCardSkeleton() {
  return (
    <div className="border border-gray-200 rounded-lg p-3 min-w-[80px] animate-pulse">
      <div className="space-y-2">
        <div className="h-3 bg-gray-200 rounded w-12 mx-auto"></div>
        <div className="h-6 bg-gray-200 rounded w-8 mx-auto"></div>
        <div className="h-3 bg-gray-200 rounded w-16 mx-auto"></div>
      </div>
    </div>
  );
}
